import { ensureArray } from '../index.js';
import { Observable } from './observable.js';

/**
 * Creates an Observable from a ResizeObserver.
 *
 * @param target one or more elements to observe
 * @param options optional ResizeObserverOptions object providing options to customize the observer.
 * @returns an Observable that emits ResizeObserverEntry objects.
 */
export const createResizeObservable = (target: Element | Element[], options?: ResizeObserverOptions) => new Observable<ResizeObserverEntry>(subscriber => {
    // create ResizeObserver and emit entries one by one to the subsciber
    const observer = new ResizeObserver(entries => entries.forEach(entry => subscriber.next(entry)));
    // register nodes to observe
    ensureArray(target).forEach(node => observer.observe(node, options));
    // add teardown logic to disconnect the observer when the subscription is disposed
    subscriber.addTeardown(() => observer.disconnect());
});
